module.exports = __webpack_public_path__ + "static/img/avatar.bca05eef.png";